<template>
  <section id="section-3" class="left-body-container">
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 class="profile-section-title">
        <i class="icon-star-half-alt"></i> نظرسنجی
      </h4>
    </div>
    <div
      class="container-fluid mt--7"
      v-if="isNotSaved && checkUserPoll === false"
    >
     <div style="text-align: center" class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
      <div v-else class="row card">
        <div class="col-12">
          <div class="card-body survey-sec">
            <p>
              به بخش نظرسنجی باشگاه مشتریان خوش آمدید . با تکمیل این بخش به
              بهبود خدمت رسانی ما و برقرار ساختن خواسته هایتان کمک کنید .
            </p>
            <h3>لطفا به کیفیت خدمات ما امتیاز دهید</h3>
            <div class="survey-top">
              <span> </span>
              <span class="survey-top-titles">
                <span id="poor">عالی<span class="vh"></span></span>
                <span id="medium">خوب<span class="vh"></span></span>
                <span id="medium">متوسط<span class="vh"></span></span>
                <span id="medium"> نامناسب<span class="vh"></span></span>
              </span>
            </div>

            <div
              class="survey-list"
              start="0"
              style="counter-reset: question 0"
            >
              <ul>
                <li class="survey-list__item" v-for="(p, index) in pollList">
                  <div class="survey-block">
                    <p id="question_part1" class="survey-title">
                      {{ p.title }}
                    </p>
                    <div class="wrapper">
                      <label v-for="r in 4">
                        <div class="icheckbox_square-grey">
                          <input
                            type="radio"
                            :value="r"
                            v-model="rating[p.id]"
                          /><label for="r26"></label>
                        </div>
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <h3>در صورت نیاز توضیحات تکمیلی خود را وارد نمایید</h3>
            <div class="group_mdi">
              <textarea
                class="style-textarea"
                type="text"
                rows="4"
                v-model="comment"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
            </div>

            <button class="btn btn-primary" @click="save">ثبت دیدگاه</button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7" v-if="isNotSaved === false">
      <div class="row card">
        <div class="col-12">
          <div class="card-body survey-sec" style="text-align: center">
            <img src="/img/survey-done.jpg" style="    border-radius: 15px;" alt="پایان نظرسنجی">
            <p class="survey-message">با سپاس از ثبت دیدگاه شما</p>
            <p class="survey-message">2 امتیاز برای شما منظور گردید.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7" v-if="checkUserPoll === true">
      <div class="row card">
        <div class="col-12">
          <div class="card-body survey-sec" style="text-align: center">
                      <img src="/img/survey-done.jpg" style="    border-radius: 15px;" alt="پایان نظرسنجی"></img>
            <p class="survey-message">شما در نظرسنجی ما شرکت نموده اید</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../store/index";
import loadingBar from "../../../components/loading/pdkLoadingBar";
var qs = require("qs");

export default {
  name: "Poll",
  store,
  components: { loadingBar },
  data() {
    return {
      serviceId: 1,
      pollType: 1,
      pollCategory: 1,
      pollList: [],
      rating: [],
      comment: "",
      isNotSaved: true,
      checkUserPoll: false,
      isLoading: false,
    };
  },
  mounted() {},
  created() {
    this.checkUserPollRegistered();
    this.getPollListByServiceId();
  },
  methods: {
    async getPollListByServiceId() {
      this.isLoading = true;
      const data = {
        serviceId: this.serviceId,
        pollType: this.pollType,
        pollCategory: this.pollCategory,
      };
      const res = await this.$store.dispatch(
        "getPollListByServiceId",
        qs.stringify(data)
      );
      this.pollList = res.data;
      this.isLoading = false;
    },
    async save() {
      const pollVote = [];
      if (Object.entries(this.rating).length === this.pollList.length) {
        Object.entries(this.rating).forEach(([key, value]) => {
          // console.log(`${key}: ${value}`);
          pollVote.push({
            id: parseInt(key.toString()),
            rate: parseInt(value),
          });
        });
        console.log(this.comment);
        console.log(this.checkForFillDesc(pollVote));

        if (this.checkForFillDesc(pollVote) !== true) {
          const data = {
            ProfileId: localStorage.getItem("UserId"),
            pollVote: pollVote,
            pollCategory: this.pollList[0].pollCategory,
            commnent: this.comment,
          };
          this.isLoading = true;
          const res = await this.$store.dispatch("createUserPoll", data);
          this.isLoading = false;
          if (res.status) {
            this.isNotSaved = false;
            this.createTransactioIncreaseOutbound();
          }
        } else {
          this.showDescriptionError(pollVote);
        }
      } else {
        this.$toast.error("!لطفا به تمام سوالات پاسخ دهید", {
          position: "bottom-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
    },
    async createTransactioIncreaseOutbound() {
      const data = {
        profileBusinessId: this.$store.getters.GetCustomerClubData.businessId,
        customerTransactionBusinessId: "00000000-0000-0000-0000-000000000000",
        serviceBusinessId:
          this.$store.getters.GetCustomerClubData.serviceBusinessId,
        providerBusinessId:
          this.$store.getters.GetCustomerClubData.providerBusinessId,
        serviceId: 1,
        providerId: 1,
        transactionType: 4,
        scoreType: 0,
        sections: 0,
        transactionDateTime: new Date(),
        reserveNumber: 0,
        registerNumber: 0,
        voucherNumber: "0",
        // detailInfo: JSON.stringify(detailInfo),
        email: localStorage.getItem("Email"),
        cellPhone: this.$store.getters.GetCustomerClubData.cellPhone,
        description: "افزایش اعتبار جهت نظرسنجی ",
        score: 2,
        usedValueAmount: 0,
        pointValue: 0,
      };
      await this.$store.dispatch("createTransactioIncreaseOutbound", data);
      this.getCustomerDataByBusiness();
    },
    async getCustomerDataByBusiness() {
      const res = await this.$store.dispatch(
        "getProfileByProfileId",
        localStorage.getItem("UserId")
      );
    },
    async checkUserPollRegistered() {
      const res = await this.$store.dispatch(
        "checkUserPollRegistered",
        localStorage.getItem("UserId")
      );
      if (res.data === true) {
        this.checkUserPoll = true;
      } else this.checkUserPoll = false;
    },
    checkForFillDesc(pollVote) {
      var temp = pollVote.filter((item) => item.rate === 1);

      if (temp.length > 0 && this.comment === "") {
        return true;
      } else {
        return false;
      }
    },
    showDescriptionError(pollVote) {
      var temp = pollVote.filter((item) => item.rate === 1);

      const myArrayFiltered = this.pollList.filter((el) => {
        return temp.some((f) => {
          return f.id === el.id;
        });
      });
      var a = [];

      for (const element of myArrayFiltered) {
        a.push(element.title);
      }

      let result = "";

      for (let i = 0; i < a.length; i++) {
        result = result.concat(a[i]);
        if (i < a.length - 1) {
          result = result.concat(",");
        }
      }
      this.$toast.error(
        " لطفا دلیل پاسخ نامناسب به " +
          result +
          "  را در قسمت توضیحات وارد کنید",
        {
          position: "bottom-center",
          timeout: 7000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        }
      );
    },
  },
};
</script>

<style lang="scss">
.sr-only {
  position: static !important;
  width: 100px !important;
  height: 100px !important;
  overflow: hidden;
  display: none;
}
.survey-message {
  font-size: 20px;
  font-weight: 600;
  margin: 30px;
}
.icheckbox_square-grey {
  width: 25px;
  height: 25px;
  cursor: pointer;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 35px;
    height: 35px;
  }
}
.left-body-container {
  .container-fluid {
    margin: 0 5%;
    width: 90%;
    .survey-sec {
      .survey-top {
        display: flex;
        padding: 0.75em;
        .survey-top-titles {
          span {
            text-align: center !important;
          }
        }
      }
      h3 {
        margin-top: 30px;
      }
      .btn-primary {
        margin: 35px;
      }
      .group_mdi {
        padding: 13px;
      }
      .style-textarea {
        border-left: 1px solid #817f7f14;
        border-right: 1px solid #817f7f14;
        border-bottom: 1px solid #d7dfe7;
        border-radius: 5px;
        border-top: none;
        max-height: 60px;
        padding: 8px;
        background: #fbfdff;
        font-size: 13px;
        -webkit-box-shadow: inset 0px 0px 6px 0px rgba(204, 214, 225, 0.5);
        -moz-box-shadow: inset 0px 0px 6px 0px rgba(204, 214, 225, 0.5);
        box-shadow: inset 0px 0px 6px 0px rgba(204, 214, 225, 0.5);
      }
      .survey-top > *:first-child {
        opacity: 0;
        width: 0;
      }
      @media (min-width: 552px) {
        .survey-top > *:first-child {
          flex-basis: 11em;
        }
      }
      .survey-top > *:last-child {
        flex-grow: 1;
        flex-basis: 20em;
        display: flex;
        flex-direction: row-reverse;
        max-width: 52%;
        margin-right: auto;
        @media (max-width: 552px) {
          max-width: 100% !important;
        }
      }
      .survey-top > *:last-child > * {
        flex-basis: 33.3333333333%;
        flex-grow: 1;
      }
      .survey-top > *:last-child > *:nth-child(2) {
        text-align: right;
      }
      .survey-top > *:last-child > *:first-child {
        text-align: right;
      }
      .survey-top > *:last-child > *:last-child {
        text-align: right;
      }
      [type="radio"]:hover + label,
      [type="radio"]:hover + input + label,
      [type="radio"]:checked + label,
      [type="radio"]:checked + input + label {
        background-color: #f7c85c;
        min-height: 1.3rem;
        min-width: 1.3rem;
        border: 1px solid #e9a916;
      }
      [type="radio"]:focus + label {
        outline: none;
        position: relative;
        z-index: 2;
      }
      [type="radio"] + label {
        display: block;
        text-align: center;
        padding: 0.5em 0;
        flex-shrink: 0;
        border: 1px solid #afafaf;
        width: 2em;
        height: 1em;
        border-radius: 50%;
        background: #fff;
        margin-left: -1px;
        margin-right: 0.25em;
        color: #fff;
        font-size: 0;
        min-height: 1.15rem;
        min-width: 1.15rem;
        -webkit-transition: all 200ms ease-in-out;
        -moz-transition: all 200ms ease-in-out;
        -ms-transition: all 200ms ease-in-out;
        -o-transition: all 200ms ease-in-out;
        transition: all 200ms ease-in-out;
      }
      [type="radio"] + label:focus,
      [type="radio"] + label:hover {
        background-color: #e9a916;
      }
      .survey-list {
        padding: 0;
        margin: 5px 5px 30px;
        list-style-type: none;
        @media (max-width: 552px) {
          ul {
            padding: 0 !important;
            width: 120%;
            margin-right: -20px;
          }
        }
        .survey-list__item {
          counter-increment: question;
          padding: 0.75em;
          &:nth-child(odd) {
            background-color: #f6f9fc;
            color: #346091;
            letter-spacing: 0;
            border-top: 1px solid #dee2e6;
            border-bottom: 1px solid #dee2e6;
          }
          .survey-block {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            .survey-title {
              -webkit-margin-end: 1rem;
              margin-inline-end: 1rem;
              -webkit-margin-after: 0.5em;
              margin-block-end: 0.5em;
              -webkit-margin-before: 0.5em;
              margin-block-start: 0.5em;
              &:before {
                content: counter(question) ". ";
              }
            }
            .wrapper {
              display: flex;
              max-width: 52%;
              justify-content: space-around;
              @media (max-width: 552px) {
                max-width: 100% !important;
              }
            }
          }
          .survey-block > *:first-child {
            flex-basis: 40%;
          }
          .survey-block > *:last-child {
            flex-grow: 1;
            flex-basis: 20em;
          }
        }
      }
      .vh {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      }
    }
  }
}
.left-body-container
  .container-fluid
  .survey-sec
  .survey-list
  .survey-list__item {
  list-style: none;
}
.vue-star-rating {
  justify-content: flex-end;
  width: 39.2em;
  .vue-star-rating-pointer {
    width: 25%;
  }
}
</style>